module.exports = __webpack_public_path__ + "img/Anhänger.4f934ddd.svg";